import { render, staticRenderFns } from "./InteractiveFlashCards.vue?vue&type=template&id=71c0cf95&scoped=true&lang=pug&"
import script from "./InteractiveFlashCards.vue?vue&type=script&lang=js&"
export * from "./InteractiveFlashCards.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveFlashCards.vue?vue&type=style&index=0&id=71c0cf95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0cf95",
  null
  
)

export default component.exports